const ComponentMap = new Map();

export const registerComponent = (name, component) => {
  ComponentMap.set(name, { kind: "sync", component });
};

export const registerAsyncComponent = (name, loader) => {
  ComponentMap.set(name, { kind: "async", loader });
};

export const getComponent = (name) => {
  return ComponentMap.get(name);
};
